import moment from "moment"

export type ChunkRange = { from: string; to: string }
export type WeekType = "isoWeek" | "week"
export type Sampling = "month" | "week" | "day" | "hour"

// 주 시작 판정의 단일 진실원 — 서버(mergeWeekOrMonth)의 isoWeek 그룹핑 파라미터와
// 청크 경계 정렬이 같은 값을 쓰도록 ApiSrv·컨트롤러 모두 이 함수를 사용해야 한다.
export function getWeekType(): WeekType {
  return moment().startOf("week").isoWeekday() === 1 ? "isoWeek" : "week"
}

const FMT = "YYYYMMDDHHmm"
// UCNT-6925가 도입한 기존 분할 크기. day/hour는 청크 경계가 자정이라 버킷이
// 쪼개지지 않으므로 그대로 유지한다.
const kLegacyChunkDays = 30
// week 샘플링의 청크 크기(4주) — 기존 30일과 비슷한 요청 무게를 유지하면서 주 경계에 정렬
const kWeeksPerChunk = 4

// UCNT-7495: 매장비교의 청크 분할 경계 계산.
// month/week 샘플링에서 고정 30일 분할은 경계가 버킷(달/주) 한가운데 떨어져,
// 서버가 같은 버킷의 부분합을 두 청크에 나눠 보내고 UI 덮어쓰기 병합이 값을
// 훼손한다. 경계를 버킷 시작에 정렬하면 한 버킷이 정확히 한 요청에만 속한다.
// weekType 생략 시 locale 기반 getWeekType()을 따른다 (ApiSrv의 isoWeek 파라미터와 동일 소스).
export function buildChunkRanges(
  from: string,
  to: string,
  sampling: Sampling,
  weekType: WeekType = getWeekType()
): ChunkRange[] {
  const end = moment.utc(to, FMT)
  const ranges: ChunkRange[] = []
  let cursor = moment.utc(from, FMT)

  while (cursor.isBefore(end)) {
    let next
    if (sampling === "month") {
      next = cursor.clone().startOf("month").add(1, "month")
    } else if (sampling === "week") {
      next = cursor.clone().startOf(weekType).add(kWeeksPerChunk, "weeks")
    } else {
      next = cursor.clone().add(kLegacyChunkDays, "days")
    }
    if (next.isAfter(end)) {
      next = end.clone()
    }
    ranges.push({ from: cursor.format(FMT), to: next.format(FMT) })
    cursor = next
  }

  return ranges
}
